import { Promise } from 'es6-promise';

import { Node } from '../constants';
import { defaultFactory as request } from '../api/RequestFactory';
import FSA from './FSA';

type ValueType = "AVG" | "MIN" | "MAX" | "ALL";

interface INodeMeasurements {
    nodeId?: string
}

interface IQuery {
    aId: string,
    start?: number,
    end?: number,
    valyeType: ValueType,
}

function fetchMeasurements(requesterId: string, params: IQuery): Promise<INodeMeasurements[]> {
    return request.get(`agent/${params.aId}/chart`, params);
}

function listMeasurements(requesterId: string, query: IQuery): Function {
    return dispatch => {
        dispatch(new FSA(Node.FETCH_MEASUREMENT_REQUEST).addMeta({ requesterId }).data);

        return fetchMeasurements(requesterId, query).then((measurements: any[]) => {
            return dispatch(new FSA(Node.FETCH_MEASUREMENT_SUCCESS).addPayload({ [query.aId]: measurements }).addMeta({ requesterId }).data);
        }, err => {
            dispatch(new FSA(Node.FETCH_MEASUREMENT_FAILURE).addError(err).addMeta({ requesterId }).data);
            throw err;
        });
    }
}

export {
    INodeMeasurements,
    fetchMeasurements,
    listMeasurements,
};


// WEBPACK FOOTER //
// ./src/actions/NodeMeasurement.ts